const COMMON = {
    EKYC__COLOR: '#00a650',
    BONDPRO__BG: '#CE9B51'
}

const DARK = {
    ...COMMON,
    PRIMARY: '#00a650',
}

const LIGHT = {
    ...COMMON,
    PRIMARY: '#00a650',
}

const CN_DARK = {
    ...DARK,
    //--Các value thay đổi cho china
}

const CN_LIGHT = {
    ...LIGHT,
    //--Các value thay đổi cho china
}

export default {
    DARK,
    LIGHT,
    CN_DARK,
    CN_LIGHT,
}
